import React from 'react';
import { useTeam, useTeamLogo } from '../hooks/team';

export default function TeamCalendar({ team, onAddToCalendar }) {
  const [teamDetails] = useTeam(team.abbrv);
  const [logo] = useTeamLogo(teamDetails?.abbrv, {
    logoImageUrl: teamDetails?.logoImageUrl,
  });

  if (!teamDetails) {
    return null;
  }

  return (
    <div className="col-12 col-md-4 col-lg-3 mb-4">
      <div className="data-container data-container--gradient p-4 d-flex flex-column justify-content-center align-items-center">
        <img
          style={{ maxHeight: 100 }}
          className="team-ticket-logo mb-4"
          src={logo}
          alt={team.abbrv}
        />
        <p className="heading-stats-name heading-stats-name--medium mt-0 mb-2 text-center">
          {team.name}
        </p>
        <p className="text-caption mb-4">{teamDetails.arena.name}</p>
        <button
          type="button"
          className="button button--primary-yellow button--large d-block text-center"
          onClick={() => onAddToCalendar(team.abbrv)}
        >
          PRENUMERERA
        </button>
      </div>
    </div>
  );
}
